export default {
  settings: {
    button: $('.trigger-load-posts'),
    target: $('.trigger-load-posts').data('target'),
    targetItems: $('.trigger-load-posts').data('target-items'),
    requestType: 'append',
    previousPosts: '',
    maxNumPages: '',
    queryVars: {
      page: 1,
      year: '',
      monthnum: '',
      day: '',
      author: '',
      taxonomy: '',
      termId: '',
      postsPerPage: $('.trigger-load-posts').data('posts-per-page'),
      view: '',
      postType: '',
      searchQuery: '',
    },
    theme: {
      ajaxurl: window.fpgmedia_js_params ? window.fpgmedia_js_params.ajaxurl : '/wp-admin/admin-ajax.php',
    },
  },

  init() {
    const scope = this;

    scope.uiActions();
    scope.detectPreviousState();
  },

  uiActions() {
    const scope = this;
    const body = $('body');

    $('.trigger-load-posts').on('click', function(e) {
      e.preventDefault();

      const self = $(this);

      self.addClass('Button--loading');
      $(scope.settings.targetItems).addClass('in');

      scope.settings.queryVars.page = self.attr('data-page');
      scope.settings.requestType = 'append';
      scope.settings.queryVars.previousPosts = '';

      scope.loadPosts();
    });

    body.on('click', '.Blurb', function() {
      const state = {
        'postId': $(this).attr('id'),
        'page': scope.settings.queryVars.page,
      }

      history.pushState(state, '');
    });
  },

  detectPreviousState() {
    const scope = this;
    let currentState = history.state;

    if (currentState && currentState.page !== 1) {
      scope.settings.queryVars.previousPosts = currentState.page * scope.settings.queryVars.postsPerPage;
      scope.settings.queryVars.page = currentState.page;

      scope.loadPosts(currentState);
      history.replaceState('', '');
    }
  },

  loadPosts(currentState) {
    const scope = this;
    const target = $(scope.settings.target);

    scope.settings.queryVars.year = scope.settings.button.data('year');
    scope.settings.queryVars.monthnum = scope.settings.button.data('monthnum');
    scope.settings.queryVars.day = scope.settings.button.data('day');
    scope.settings.queryVars.author = scope.settings.button.data('author');
    scope.settings.queryVars.taxonomy = scope.settings.button.data('taxonomy');
    scope.settings.queryVars.termId = scope.settings.button.data('term-id');
    scope.settings.queryVars.postsPerPage = scope.settings.button.data('posts-per-page');
    scope.settings.queryVars.view = scope.settings.button.data('view');
    scope.settings.queryVars.searchQuery = scope.settings.button.data('search-query');
    scope.settings.queryVars.maxNumPages = scope.settings.button.data('max-num-pages');
    scope.settings.queryVars.postType = scope.settings.button.data('post-type');

    const data = {
      action: 'load_posts',
      page: scope.settings.queryVars.page,
      year: scope.settings.queryVars.year,
      monthnum: scope.settings.queryVars.monthnum,
      day: scope.settings.queryVars.day,
      author: scope.settings.queryVars.author,
      taxonomy: scope.settings.queryVars.taxonomy,
      termId: scope.settings.queryVars.termId,
      previousPosts: scope.settings.queryVars.previousPosts,
      postsPerPage: scope.settings.queryVars.postsPerPage,
      view: scope.settings.queryVars.view,
      searchQuery: scope.settings.queryVars.searchQuery,
      maxNumPages: scope.settings.queryVars.maxNumPages,
      postType: scope.settings.queryVars.postType,
      blurbFeatured: scope.settings.button.data('blurb-featured'),
    };

    $.ajax({
      type: 'POST',
      url: scope.settings.theme.ajaxurl,
      data: data,

      success: function(response) {
        if (!response.success) {
          return false;
        }

        if (!response.data.ret) {
          return false;
        }

        scope.settings.button.attr('data-page', response.data.ret.page);
        scope.settings.button.attr('href', '?paged=' + response.data.ret.page);

        if (scope.settings.requestType === 'append') {
          target.append(response.data.ret.results);
        } else {
          target.html(response.data.ret.results);
        }

        if (!currentState) {
          $(scope.settings.targetItems + ':not(".in")').addClass('out');
        }

        if (false === response.data.ret.have_more) {
          scope.settings.button.parent().addClass('d-none');
          $(scope.settings.target).addClass('completed');
        } else {
          scope.settings.button.parent().removeClass('d-none');
        }
      },

      complete: function() {
        scope.settings.button.removeClass('Button--loading');

        if (currentState) {
          setTimeout(function() {
            $('html, body').animate({
              scrollTop: $('#' + currentState.postId).offset().top -50,
            }, 0);
          }, 250);
        } else {
          setTimeout(function() {
            $(scope.settings.targetItems + '.out').each(function() {
              $(this).removeClass('out');
            });
          }, 250);
        }
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pager.js